<div class="toast-wrapper">
  <Toast />
</div>